module.exports = __webpack_public_path__ + "static/media/sungreen.65464df5.svg";